import { render, staticRenderFns } from "./succ.vue?vue&type=template&id=4cbc25c7&scoped=true&"
import script from "./succ.vue?vue&type=script&lang=js&"
export * from "./succ.vue?vue&type=script&lang=js&"
import style0 from "./succ.vue?vue&type=style&index=0&id=4cbc25c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbc25c7",
  null
  
)

export default component.exports